import {config} from "../config";

const createBrowserHistory = require('history').createBrowserHistory;


export const parseSearch = (search: string) => {
    if (search === "") return {}
    if (search.indexOf("?") !== 0) return {}
    search = search.substr(1)
    let match: any = {};
    let iterator = search.matchAll(/([^=]+)=([^=&]+)&?/g)
    const result: { [key: string]: any } = {}
    while (true) {
        match = iterator.next()
        if (match.done) break;
        result[match.value[1]] = match.value[2];
    }

    return result
}

const appHistory = createBrowserHistory({ basename: config.basename });
appHistory.search = (name?: string, def?: any) => {
    const search = parseSearch(appHistory.location.search)
    if (name) {
        return search[name]??def
    }
    return search
}
appHistory.successOperation = () => {
    if (appHistory.search('close') === '1') {
        window.close()
    } else {
        if (appHistory.length === 0) window.close()
        appHistory.go(-1)
    }
}

let titleLeft = ""
let sectionName = ""
appHistory.title = (title: string) => {
    titleLeft = title
    document.title = titleLeft + " - " + sectionName
}

appHistory.section = (section: string) => {
    sectionName = section
    document.title = titleLeft + " - " + section
}
export default appHistory

